export default "__VITE_ASSET__BUNwRG1g__"